export default __webpack_public_path__ + "static/media/plus.d6bc5b5b.svg";